import { memo, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { RoutePath } from 'consts/RoutePath';
import { GroupAuth } from 'consts/GroupAuthConst';
import { GroupWithLoginUser } from 'requests/RequestGroup';

type Props = {};
type LeaveFamilyDto = {
	group: GroupWithLoginUser;
};

export const LeaveFamilyTemplate = memo((_props: Props) => {
	const history = useHistory<LeaveFamilyDto>();
	const dto = history.location.state;
	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = '「家族」から抜ける';
	}, []);

	return (
		<>
			<section className="section mypage" ref={scrollRef}>
				<div className="breadcrumb">
					<ul>
						<li>
							<Link to={RoutePath.MY_PAGE}>マイページTOP</Link>
						</li>
						<li>
							<Link to={RoutePath.FAMILY_INFO}>家族情報</Link>
						</li>
						<li>「家族」から抜ける</li>
					</ul>
				</div>
				<h1 className="page-head">「家族」から抜ける</h1>
				<div className="section-in" style={{ marginTop: 50 }}>
					<div className="section-head">
						<span>自分だけ抜ける</span>
					</div>
					<div className="section-txt-box">
						<div className="txt">
							<div>現在所属している「家族」から、ご自身が抜ける場合はこちらから手続きが可能です。</div>
						</div>
					</div>
					<div className="btn-box">
						<div className="btn gr">
							<Link to={{ pathname: RoutePath.LEAVE_FAMILY_ONLY, state: dto }}>
								<span>「家族」から抜ける</span>
							</Link>
						</div>
					</div>
				</div>
				<div className="section-in" style={{ marginTop: 20 }}>
					<div className="section-head">
						<span>{`Gakken${GroupAuth.MEMBER.name}のユーザーと一緒に抜ける`}</span>
					</div>
					<div className="section-txt-box">
						<div className="txt">
							<div>{`現在所属している「家族」から、Gakken${GroupAuth.MEMBER.name}のユーザーと一緒に抜ける場合はこちらから手続きが可能です。`}</div>
						</div>
					</div>
					<div className="btn-box">
						<div className="btn gr">
							<Link to={{ pathname: RoutePath.LEAVE_FAMILY_TOGETHER, state: dto }}>
								<span>「家族」から抜ける</span>
							</Link>
						</div>
					</div>
				</div>
			</section>
		</>
	);
});
